/**
 * 登录相关的 用户信息
 */
import { useAuthStore } from '../stores/auth'
const baseUrl = import.meta.env.VITE_API_BASE_URL
import { showNotify } from 'vant'
import router from '../router/index';

// 用户信息接口
export interface appUserInfo {
  accessToken: string,
  userPhone: string,
  userName?: string,
  userAvatar?: string,
}
// 小程序服务类
export class appApi {
  private static readonly ACCESS_TOKEN_KEY = 'app_access_token'; // 项目的 accsess-token
  private static readonly TOKEN_EXPIRE_TIME = 24 * 60 * 60 * 1000; // 30分钟过期时间

  /**
   * 获取存储的 accessToken
   */
  private static getStoredToken(): string | null {
    const tokenData = localStorage.getItem(this.ACCESS_TOKEN_KEY);
    if (!tokenData) {
      return null;
    }

    try {
      const { token } = JSON.parse(tokenData);
      return token;
    } catch (error) {
      return null;
    }
  }

  /**
   * 清除存储的 accessToken
   */
  static clearStoredToken(): void {
    localStorage.removeItem(this.ACCESS_TOKEN_KEY);
    localStorage.removeItem('userInfo');
    localStorage.setItem('hasLoggedWithParams', 'false');
    const authStore = useAuthStore();
    authStore.clearUserInfo();
  }

  /**
   * 获取有效的 accessToken
   */
  static getValidAccessToken(): string | null {
    return this.getStoredToken();
  }

  /**
   * 小程序登录处理-解密获取用户信息
   */
  static async handleLogin(finalEncryptedParams:any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      localStorage.setItem('hasLoggedWithParams', 'false');
      try {
        const response = await fetch(baseUrl + '/repair/wechat/login?sessionKey=' + finalEncryptedParams, {
          method: 'GET',
        })
        const result: ApiResponse<appUserInfo> = await response.json()
        if (result.error === '401') { // 加密串在后端查询不到有效的token
          this.clearStoredToken()
          showNotify({
            type: 'warning',
            message: '请先注册/登录后再操作',
            duration: 3000
          });
          // 跳转到登录页
          if (router) {
            setTimeout(() => {
              const currentRoute = router.currentRoute.value;
              if (!currentRoute || currentRoute.path !== '/user') {
                router.push('/user').catch(err => {
                  console.error('401跳转登录页失败:', err);
                });
              }
            }, 1500);
          } else {
            console.error('路由实例未找到，无法跳转到登录页');
          }
          resolve(result.error);
        } else {
          localStorage.setItem('hasLoggedWithParams', 'true');
          result.result.userName ? '' : result.result.userName = result.result.userPhone
          const tokenData = {
            'token': result.result.accessToken,
          };
          localStorage.setItem(this.ACCESS_TOKEN_KEY, JSON.stringify(tokenData));
          // 存储用户信息到 pinia store
          const authStore = useAuthStore();
          authStore.setUserInfo(result.result);
          localStorage.setItem('userInfo', JSON.stringify(result.result));
          resolve(result.result);
        }
      } catch (error) {
        // 清空
        this.clearStoredToken()
        const errorMsg = (error as any).error || '获取用户信息失败';
        throw new Error(errorMsg);
      }
    });
  }
  static async loginOutAPI(): Promise<any> {
    const response = await fetch(baseUrl + '/repair/wechat/logout', {
      method: 'GET',
    } as any)
    const result: ApiResponse<any> = await response.json()
    return result.result
  }
  static async sendCodeAPI(phone: string): Promise<any> {
    let data:{ [key: string]: any } = {
      phone: phone
    }
    const response = await fetch(baseUrl + '/repair/wechat/sendCode', {
      method: 'POST',
      showLoading: true,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    } as any)
    const result: ApiResponse<any> = await response.json()
    return result.result
  }
  static async smsLoginAPI(phone: string, code: string): Promise<any> {
    let data:{ [key: string]: any } = {
      phone: phone,
      code: code
    }
    const response = await fetch(baseUrl + '/repair/wechat/smsLogin', {
      method: 'POST',
      showLoading: true,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    } as any)
    const result: ApiResponse<any> = await response.json()
    return result.result
  }
}
export default appApi